import React, { useState, useEffect } from "react";
import { HeaderWithBottomLine } from "../HeaderWithBottomLine";
import { Row, Col, Form, Input, Select, Radio } from "antd";
import {
  checkSpace,
  checkSpecialCharacter,
  checkNumbervalue,
} from "../../../../utils";

export function MiscellaneousInput({ details, itemkey }) {
  const [ownVehicle, setOwnVehicle] = useState(false);
  let lg = 12;
  let sm = 12;
  let md = 12;
  let xs = 24;
  const radioGap = {
    display: "flex",
    columnGap: "4rem",
  };

  useEffect(() => {
    if (itemkey === 4) {
      setOwnVehicle(details?.checkVehicleAvailability);
    }
  }, [itemkey]);

  return (
    <>
      <HeaderWithBottomLine text={"Miscellaneous Details"} icon={false} />
      <Row gutter={40} className="basic-details-conten global-form-row">
        <Col lg={12}>
          <Form.Item
            name="Experience"
            label={"Experience in courier industry (in years)"}
            onKeyPress={(event) => {
              if (checkNumbervalue(event) || checkSpace(event)) {
                event.preventDefault();
              }
            }}
            rules={[
              {
                pattern: /^[0-9].*/g,
                message: "Initial value should be numeric.",
              },
              {
                pattern: /^\d{1,2}(\.\d{0,2})?$/,
                message: "Invalid experience",
              },
            ]}
          >
            <Input
              placeholder="0"
              type="text"
              maxLength={5}
              onKeyPress={(e) => {
                if (/[^0-9.]/.test(e.key)) {
                  e.preventDefault();
                }
              }}
            />
          </Form.Item>
        </Col>
        <Col lg={12}>
          <Form.Item
            name="previousCompany"
            label={"Name of the previous courier company"}
          >
            <Input
              placeholder="Enter previous company name"
              type="text"
              maxLength={50}
            />
          </Form.Item>
        </Col>
        <Col lg={12}>
          <Form.Item
            name="MonthlyTurnover"
            label={"Monthly turnover (approximate)"}
            onKeyPress={(event) => {
              if (checkNumbervalue(event) || checkSpace(event)) {
                event.preventDefault();
              }
            }}
            rules={[
              {
                pattern: /^\d{1,10}(\.\d{0,2})?$/,
                message: "Invalid turnover",
              },
              // () => ({
              //   validator(rule, value = "") {
              //     if (value.substring(1, 0) === " ") {
              //       return Promise.reject("Invalid turnover");
              //     } else {
              //       return Promise.resolve();
              //     }
              //   },
              // }),
            ]}
          >
            <Input placeholder="0" type="text" maxLength={20} />
          </Form.Item>
        </Col>
        <Col lg={12}>
          <Form.Item
            name="OwnerShip"
            label={
              <span className="calculater-container-pikpin">
                Office ownership
              </span>
            }
            rules={[
              {
                required: true,
                message: "Please select value",
              },
            ]}
          >
            <Select
              placeholder="Select ownership"
              options={[
                {
                  value: "Owned",
                  label: "Owned",
                },
                {
                  value: "Rented",
                  label: "Rented",
                },
              ]}
            />
          </Form.Item>
        </Col>
        <Col lg={12}>
          <Form.Item
            name="officeArea"
            label={"Office area in sq. ft."}
            onKeyPress={(event) => {
              if (
                checkNumbervalue(event) || // checkSpecialCharacter(event) ||
                checkSpace(event)
              ) {
                event.preventDefault();
              }
            }}
            rules={[
              {
                required: true,
                message: "Please enter value",
              },
              {
                pattern: /^\d{1,10}(\.\d{0,2})?$/,
                message: "Invalid office area",
              },
              // () => ({
              //   validator(rule, value = "") {
              //     if (value.substring(1, 0) === " ") {
              //       return Promise.reject("Invalid Office area");
              //     } else {
              //       return Promise.resolve();
              //     }
              //   },
              // }),
            ]}
          >
            <Input placeholder="0" type="text" maxLength={20} />
          </Form.Item>
        </Col>
        <Col lg={12}>
          <Form.Item
            name="staff"
            label={"No. of staff"}
            onKeyPress={(event) => {
              if (
                checkNumbervalue(event) ||
                checkSpecialCharacter(event) ||
                checkSpace(event)
              ) {
                event.preventDefault();
              }
            }}
            rules={[
              {
                required: true,
                message: "Please select value",
              },
            ]}
          >
            <Input
              placeholder="Enter number of staff"
              type="text"
              maxLength={3}
            />
          </Form.Item>
        </Col>
        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item
            name="checkVehicleAvailability"
            label={
              <span className="calculater-container-pikpin">
                If CP owns vehicle for First mile delivery?
              </span>
            }
          >
            <Radio.Group
              style={radioGap}
              onChange={(e) => setOwnVehicle(JSON.parse(e.target.value))}
              defaultValue={false}
              // value={isMiniHub}
              rules={[
                {
                  required: true,
                  message: "Please select value",
                },
              ]}
            >
              <Radio value={true}>Yes</Radio>
              <Radio value={false}>No</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
        {ownVehicle && (
          <>
            <Col lg={lg} md={md} sm={sm} xs={xs}>
              <Form.Item
                name="numberOfVehicles"
                label={"No. of Vehicle"}
                onKeyPress={(event) => {
                  if (
                    checkNumbervalue(event) ||
                    checkSpecialCharacter(event) ||
                    checkSpace(event)
                  ) {
                    event.preventDefault();
                  }
                }}
                rules={[
                  {
                    required: true,
                    message: "Please select value",
                  },
                ]}
              >
                <Input
                  placeholder="Enter number of vehicle"
                  type="text"
                  maxLength={2}
                />
              </Form.Item>
            </Col>
          </>
        )}
      </Row>
    </>
  );
}
